module.exports = __webpack_public_path__ + "files/28a90af3e37b7b56a99a4047c0361c50.png";